// extracted by css-extract-rspack-plugin
export default {"supportLink":"_536bddf1"};